export default "__VITE_ASSET__9552afef__"